import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import "../CSS/Dashboad.css";
const UsersOverviewOne = ({ thirdPartyReviews }) => {
  const [donutChartSeries, setDonutChartSeries] = useState([]);
  const [donutChartLabels, setDonutChartLabels] = useState([]);

  const colorMapping = {
    WowReview: "bg-danger-500",
    Google: "bg-yellow",
    Facebook: "bg-primary-600",
    MakeMyTrip: "bg-success-600",
    Tripadvisor: "bg-tripadvisor",
    Goibibo: "bg-warning-900",
    Agoda: "bg-neutral-500",
  };

  useEffect(() => {
    // Dynamically setting the series and labels based on third-party review data
    if (thirdPartyReviews && thirdPartyReviews.length > 0) {
      const series = thirdPartyReviews.map(
        (review) =>
          parseInt(review.negative_count) + parseInt(review.positive_count)
      );
      const labels = thirdPartyReviews.map((review) => review.platform);

      setDonutChartSeries(series);
      setDonutChartLabels(labels);
    }
  }, [thirdPartyReviews]);

  let donutChartOptions = {
    colors: [
      "var(--yellow)",
      "var(--danger-500)",

      "var(--primary-600)",
      "var(--success-600)",

      "var(--warning-900)",
      " var(--neutral-500)",
    ],
    labels: donutChartLabels,
    legend: {
      show: false,
    },
    chart: {
      type: "donut",
      height: 270,
      sparkline: {
        enabled: true,
      },
      animations: {
        enabled: false,
      },
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    stroke: {
      width: 0,
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
            height: "200px",
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div className="col-xxl-4 col-xl-6">
      <div className="card h-100 radius-8 border-0 overflow-hidden">
        <div className="card-body p-24 ">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-3 fw-bold text-lg">Reviews by Source</h6>
          </div>

          <div className="cicleGraphSection">
            {" "}
            {donutChartSeries.length > 0 && (
              <ReactApexChart
                options={donutChartOptions}
                series={donutChartSeries}
                type="donut"
                height={264}
              />
            )}
            <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
              {thirdPartyReviews.map((platform, index) => (
                <li key={index} className="d-flex align-items-center gap-2">
                  <span
                    className={`w-12-px h-12-px radius-2 ${
                      colorMapping[platform.platform] || "bg-neutral-500"
                    }`}
                  />
                  <span className="text-secondary-light fw-semibold text-sm fw-normal">
                    {platform.platform}:
                    <span className="text-primary-light fw-semibold">
                      {parseInt(platform.negative_count) +
                        parseInt(platform.positive_count)}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersOverviewOne;
